import Vue from 'vue'
let $vue = new Vue();

import store from "../store/index";
export default {

  //修改网站标题
  updateWebTitle(str) {
    document.title = str;
  },
  //清除两边空格
  trim(str) {
    str = str.replace(/^\s*|\s*$/g, "");
    return str;
  },
  //获取文件格式,image(图片),video(视频),pdf(pdf),other(其他格式，如zip,doc,excel)
  getFileType(str) {
    let type = str.substring(str.lastIndexOf(".") + 1, str.length).toLowerCase();
    if (['jpg', 'png', 'jpeg'].includes(type)) {
      return 'image'
    } else if (['avi', 'mp4', 'm4v', 'rmvb', 'mkv', 'mp3', 'wav'].includes(type)) {
      return 'video'
    } else if (['pdf'].includes(type)) {
      return 'pdf'
    } else {
      return 'other'
    }
  },

  //查看图片方法
  lookImage(params) {

    let randomNum = new Date().getTime() + this.getRandom() + '';
    let type = this.getDataType(params);

    let data;
    if (type == 'array') {
      data = JSON.stringify(params);
    }
    //把数据存到localStorage
    localStorage.setItem(randomNum, data);
    //打开新弹窗
    let route = `/lookImage?id=${randomNum}`;

    window.open(route, window, "scrollbars=yes,top=50px,left=230px,width=2000px,height=1000px");
  },

  clearEmptyParam(params) {
    const transformData = JSON.parse(JSON.stringify(params));
    const isArray = Array.isArray(transformData);
    if (
      typeof transformData === "object" &&
      !isArray &&
      transformData !== null
    ) {
      for (const [k, v] of Object.entries(transformData)) {
        if (v !== 0 && !v && typeof v !== "boolean") {
          delete transformData[k];
        } else if (isArray && v.length == 0) {
          delete transformData[k];
        }
      }
    }
    return transformData;
  },

  //导出表格方法,params/参数，title/导出表格的文件名,myUrl:api地址
  exportData(params, title, myUrl) {
    let url = myUrl;
    $vue.HttpService({
      method: 'post',
      url: url,
      data: params,
      responseType: 'blob'
    }).then((response) => {
      if (response) {
        let url = window.URL.createObjectURL(new Blob([response]));
        let link = document.createElement('a');
        link.style.display = 'none';
        link.href = url;
        link.setAttribute('download', title + '.xlsx');
        document.body.appendChild(link);
        link.click();
      }
    }, (err) => {
      console.log(err);
      const reader = new FileReader();
      reader.onload = (item) => {
        if (!item.target || !item.target.result) {
          $vue.$error({
            title: '提示',
            content: '下载不成功',
          });
        }
        $vue.$error({
          title: '提示',
          content: JSON.parse(item.target.result).message,
        });
      };
      reader.readAsText(err.response.data);
    })
  },

  //通用导出表格方法
  //url:导出表格接口，params:参数,title：导出表格的名称
  exportExcel(url, params, title, method = 'post') {

    return new Promise((resolve, reject) => {

      $vue.HttpService({
        method: method,
        url: url,
        data: params,
        responseType: 'blob'
      }).then((response) => {
        if (response) {
          let url = window.URL.createObjectURL(new Blob([response]));

          let link = document.createElement('a');
          link.style.display = 'none';
          link.href = url;
          let fileName = title;
          link.setAttribute('download', fileName + '.xlsx');
          document.body.appendChild(link);
          link.click();
          resolve(true)
        }
      }, err => {

        reject(err)
      })
    })


  },

  //二进制流数据转换为url地址,type: pdf,zip,video
  binaryData2Url(url, params, type = 'pdf') {
    return new Promise((resolve) => {
      $vue.HttpService({
        method: 'post',
        url: url,
        data: params,
        responseType: 'arraybuffer'
      }).then((res) => {
        let flag;
        switch (type) {
          case 'pdf':
            flag = "application/pdf"
            break;
          case 'video':
            flag = "application/ogg";
            break;
          case 'zip':
            flag = 'application/zip';
        }
        url = window.URL.createObjectURL(new Blob([res], { type: flag }));
        resolve(url);
      })
    })
  },


  //excel文件流处理
  excelFileExport(url, params, title, type = '.xlsx') {

    $vue.HttpService({
      method: 'post',
      url: url,
      data: params,
      responseType: 'blob'
    }).then((response) => {

      if (response) {
        let url = window.URL.createObjectURL(new Blob([response]));
        if (type == '.zip') {
          url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/zip' }));
        }
        let link = document.createElement('a');
        link.style.display = 'none';

        link.href = url;
        link.setAttribute('download', title + type);
        document.body.appendChild(link);
        link.click();
      }
    }, (err) => {
      console.log(err);
      const reader = new FileReader();
      reader.onload = (item) => {
        if (!item.target || !item.target.result) {
          $vue.$error({
            title: '提示',
            content: '下载不成功',

          });
        }
        $vue.$error({
          title: '提示',
          content: JSON.parse(item.target.result).message,

        });
      };
      reader.readAsText(err.response.data);
    })
  },
  EExport(myUrl, params) {
    let url = myUrl;
    $vue.HttpService({
      method: 'post',
      url: url,
      data: params,
      responseType: 'blob'
    }).then((response) => {
      if (response) {
        let url = window.URL.createObjectURL(new Blob([response]));
        let link = document.createElement('a');
        link.style.display = 'none';
        link.href = url;
        let title = "定制E盘导出"
        link.setAttribute('download', title + '.xlsx');
        document.body.appendChild(link);
        link.click();
      }
    }, (err) => {
      console.log(err);
      const reader = new FileReader();
      reader.onload = (item) => {
        if (!item.target || !item.target.result) {
          $vue.$error({
            title: '提示',
            content: '下载不成功',
          });
        }
        $vue.$error({
          title: '提示',
          content: JSON.parse(item.target.result).message,
        });
      };
      reader.readAsText(err.response.data);
    })
  },



  //深拷贝
  copy(params) {
    return JSON.parse(JSON.stringify(params));
  },

  //获取变量类型
  getDataType(data) {
    return Object.prototype.toString.call(data).slice(8, -1).toLowerCase();
  },

  //检测文本框长度限制，（中文检测）
  checkLength($event, obj, params) {
    let target = $event.currentTarget;
    let maxLength = target.maxLength;
    let l = 0;
    let arr = params.split('.');
    for (var i = 0; i < target.value.length; i++) {
      if (/[\u4e00-\u9fa5]/.test(target.value[i])) {
        l += 2;
      } else {
        l++;
      }
      if (l > maxLength) {
        if (arr.length == 3) {
          obj[arr[0]][arr[1]][arr[2]] = target.value.substr(0, i);
        } else if (arr.length == 2) {
          obj[arr[0]][arr[1]] = target.value.substr(0, i);
        } else {
          obj[arr[0]] = target.value.substr(0, i);
        }

        // obj.data.tblAzAssignLcLsDto.gcbh = target.value.substr(0, i);
        break;
      }
    }
  },

  //判断是否为数字
  isNumber(value) {
    return typeof value === 'number' && !isNaN(value);
  },

  //检测字符是否超出最大长度（含中英文）,如果tips有传值，弹出相关提示
  checkStrLength(str, maxLength, tips) {
    let flag = true;
    let l = 0;
    for (var i = 0; i < str.length; i++) {
      if (/[\u4e00-\u9fa5]/.test(str[i])) {
        l += 2;
      } else {
        l++;
      }
      if (l > maxLength) {
        flag = false;
        if (tips) {
          $vue.$message.warning(tips);
        }
        break;
      }
    }
    return flag;
  },

  //默认，type=0,控制文本框只能输入数字，英文和下划线, type=1，限制非特殊字符, type=2,只能输入数字
  inputControl($event, obj, params, type = 0) {
    let target = $event.currentTarget;
    let arr = params.split('.');
    let value = target.value;
    let reg = /[^a-zA-Z0-9_]/g;
    if (type == 1) {
      reg = /[^\a-\z\A-\Z0-9\u4E00-\u9FA5\.\_\-\s\:]/g;
    }
    if (type == 2) {
      reg = /[^0-9]/g;
    }
    if (arr.length == 3) {
      obj[arr[0]][arr[1]][arr[2]] = target.value.replace(reg, '');
    } else if (arr.length == 2) {
      //obj[arr[0]][arr[1]]=target.value.replace(reg,'');
      let type = this.getDataType(obj[arr[0]]);
      if (type == 'array') {
        obj[arr[0]][0][arr[1]] = target.value.replace(reg, '');
      } else if (type == 'object') {
        obj[arr[0]][arr[1]] = target.value.replace(reg, '');
      }

    } else {
      obj[arr[0]] = target.value.replace(reg, '');
    }
  },

  //处理空的时间
  handleTime(data) {
    let flag = (data && (data == 'null' || data.indexOf('1970-') >= 0 || data == 0))
    if (!data || flag) {
      return '';
    }
    return data;
  },

  //判断变量是否为空值
  handleEmptyData(data) {

    if (data == 'undefined' || data == undefined || data === "" || data == null || data == "null" || data.length == 0 || JSON.stringify(data) === '{}') {
      return true;
    }
    return false;
  },

  //判断当前运行环境是否为生产环境
  isProductHost() {
    if (window['_FLY_GLOBAL_CONFIG']['auth.config'].oauth_url == 'https://apishyun.gree.com') {
      return true;
    }
    return false;
  },

  //ant-design-vue，a-range-date，不能选择大于今天时间
  disabledAfterToDay(current) {
    return current && current > $vue.moment().endOf('day');
  },

  //获取当前时间
  getCurTime() {
    return $vue.moment(new Date()).format("YYYY-MM-DD HH:mm:ss");
  },

  //将TZ时间转为YYYY-MM-DD HH:mm:ss格式时间
  changeTzToTime(str) {
    return $vue.moment(str).format("YYYY-MM-DD HH:mm:ss");
  },

  //获取限制日期，如今天2-2号，获取2-3号，如一些报修日期不能超过今天
  getMaxDate() {
    let maxDate = $vue.moment().startOf('day').format('YYYY-MM-DD HH:mm:ss');
    return maxDate;
  },

  //length:长度,
  //type,默认为数字，1为数字加英文
  getRandom(length, type) {
    let chars = '0123456789';
    if (type) {
      chars += 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ'
    }
    let maxPos = chars.length;
    let code = '';
    for (let i = 0; i < 6; i++) {
      code += chars.charAt(Math.floor(Math.random() * maxPos));
    }
    return code;
  },

  // 判断对象的值是不是全为空
  objectValueAllEmpty(object) {
    let isEmpty = true;
    Object.keys(object).forEach(function(x) {
      if (object[x] != null && object[x] != "") {
        isEmpty = false;
      }
    });
    if (isEmpty) {//值全为空
      return true;
    }
    return false;
  },

  //返回事件
  back(obj) {
    obj.$router.go(-1);
  },

  //全局提示信息框 info
  info(content, title = '提醒', width) {
    $vue.$info({
      content: content,
      width: width,
      title: title,
      okText: "确认",
      onOK() { }
    })
  },

  //全局警告信息框 warning
  warning(content, title = '提示') {
    $vue.$warning({
      content: content,
      title: title
    })
  },

  //全局确认框信息
  confirm(content, okFun, cancelFun) {
    // console.log($vue.$confirm, "vue")
    $vue.$confirm(
      content,
      '提示',
      {}).then(() => {
        okFun && okFun()
      }).catch(() => {
        cancelFun && cancelFun()
      });
  },

  //全局错误提示，点击确认后返回
  error(content, okFun, cancelFun) {
    $vue.$error({
      title: '提示',
      content: content,
      onOk() {
        okFun && okFun()
      },
      onCancel() {
        cancelFun && cancelFun()
      }
    });
  },

  //全局成功，点击确认后返回
  success(content, okFun, cancelFun) {
    $vue.$success({
      title: '提示',
      content: content,
      onOk() {
        okFun && okFun()
      },
      onCancel() {
        cancelFun && cancelFun()
      }
    });
  },


  //控制时间区间时间控制
  //type:'hour',控制开始时，'minute',控制开始分,
  //endTime:结束时间,smsjDate:上门时间日期
  //$event：选中的数据
  disStartTime(type, endTime, smsjDate, $event) {
    if (type == 'hour') {
      let hours = []
      if (endTime) {
        let time = endTime
        let timeArr = time.split(':') //13:00
        for (var i = parseInt(timeArr[0]) + 1; i < 24; i++) {
          hours.push(i)
        }
      }
      //判断是否为同一天
      if ($vue.moment().format('YYYY-MM-DD') == $vue.moment(smsjDate).format('YYYY-MM-DD')) {
        let time = $vue.moment().format('HH:mm');
        let timeArr = time.split(':') //13:00
        for (var i = 0; i < parseInt(timeArr[0]); i++) {
          hours.push(i)
        }
      }
      return hours
    } else if (type == 'minute') {
      let minutes = []
      if (endTime) {
        let time = endTime
        let timeArr = time.split(':')
        if ($event == parseInt(timeArr[0])) {
          for (var i = parseInt(timeArr[1]); i < 60; i++) {
            minutes.push(i)
          }
        }
      }
      //判断是否为同一天和同一个小时
      if ($vue.moment().format('YYYY-MM-DD') == $vue.moment(smsjDate).format('YYYY-MM-DD') && $vue.moment().format('HH') == $event) {
        let time = $vue.moment().format('HH:mm');
        let timeArr = time.split(':') //13:00
        for (var i = 0; i < parseInt(timeArr[1]) + 1; i++) {
          minutes.push(i)
        }
      }
      return minutes;
    }
  },

  //控制时间区间时间控制
  //type:'hour',控制结束时，'minute',控制结束分,
  //startTime:开始时间
  //$event：选中的时间数据
  disEndTime(type, startTime, $event) {
    if (type == 'hour') {
      let hours = []
      let time = startTime
      let timeArr = time.split(':')
      for (var i = 0; i < parseInt(timeArr[0]); i++) {
        hours.push(i)
      }
      return hours;
    } else if (type == 'minute') {
      let time = startTime
      let timeArr = time.split(':')
      let minutes = []
      if ($event == parseInt(timeArr[0])) {
        for (var i = 0; i <= parseInt(timeArr[1]); i++) {
          minutes.push(i)
        }
      }
      return minutes;
    }
  },

  //整理时间，转成TZ格式的时间，如2021-02-12Ss13:02:00T
  changeTimeToTZ(date, time) {
    let tempTime = null;
    let start = $vue.moment(date).format(`YYYY-MM-DD `) + (typeof time === 'string' ? time : time.format('HH:mm'));
    tempTime = $vue.moment(start).utcOffset('Z').format(`YYYY-MM-DDTHH:mm:ss.SSZ`);
    return tempTime;
  },

  //处理列表时间搜索参数,showTime:绑定的值，searchTime：请求接口参数值,oldTime:保存的时间值（作对比用）
  changeTime(obj, showTime, searchTime, oldTime) {
    if (obj[showTime][0] == undefined || obj[showTime][1] == undefined) {
      obj.vueFlyAdvanceSearchOptions.criteria[searchTime].greaterOrEqualThan = null;
      obj.vueFlyAdvanceSearchOptions.criteria[searchTime].lessOrEqualThan = null;
      return
    }

    //如果是同一天
    let startDate = obj.moment(obj[showTime][0]).format(`YYYY-MM-DD`);
    let endDate = obj.moment(obj[showTime][1]).format(`YYYY-MM-DD`);
    let oldStartDate, oldEndDate;
    if (obj[oldTime] && obj[oldTime].length > 0) {
      oldStartDate = obj.moment(obj[oldTime][0]).format(`YYYY-MM-DD`);
      oldEndDate = obj.moment(obj[oldTime][1]).format(`YYYY-MM-DD`);
    }

    let start, end;
    //如果是修改时分秒
    if (startDate == oldStartDate && endDate == oldEndDate) {
      start = obj.moment(obj[showTime][0]).format(`YYYY-MM-DD HH:mm:ss`);
      end = obj.moment(obj[showTime][1]).format(`YYYY-MM-DD HH:mm:ss`)
    } else {
      start = obj.moment(obj[showTime][0]).format(`YYYY-MM-DD`) + " 00:00:00";
      end = obj.moment(obj[showTime][1]).format(`YYYY-MM-DD`) + " 23:59:59"
    }
    obj[showTime] = [start, end];
    obj[oldTime] = [start, end];
    if (!obj.vueFlyAdvanceSearchOptions.criteria[searchTime]) {
      obj.$set(obj.vueFlyAdvanceSearchOptions.criteria, searchTime, {});
    }
    obj.vueFlyAdvanceSearchOptions.criteria[searchTime].greaterOrEqualThan = start;
    obj.vueFlyAdvanceSearchOptions.criteria[searchTime].lessOrEqualThan = end;

  },

  //电话验证(包括固话)
  checkPhone(phoneNum) {
    // let regex =/^((13[0-9])|(14[5|7])|(15([0-3]|[5-9]))|(18[0,5-9]))\d{8}$|^((13[0-9])|(14[5|7])|(15([0-3]|[5-9]))|(18[0,5-9]))\d{8}$|^0\d{2,3}-?\d{7,8}$/;
    var regex = /^1[3456789]\d{9}$|^0\d{2,3}-?\d{7,8}$/;
    return regex.test(phoneNum);
  },

  //身份证校验
  checkShenfenId(id) {
    var checkProv = function(val) {
      var pattern = /^[1-9][0-9]/;
      var provs = { 11: "北京", 12: "天津", 13: "河北", 14: "山西", 15: "内蒙古", 21: "辽宁", 22: "吉林", 23: "黑龙江 ", 31: "上海", 32: "江苏", 33: "浙江", 34: "安徽", 35: "福建", 36: "江西", 37: "山东", 41: "河南", 42: "湖北 ", 43: "湖南", 44: "广东", 45: "广西", 46: "海南", 50: "重庆", 51: "四川", 52: "贵州", 53: "云南", 54: "西藏 ", 61: "陕西", 62: "甘肃", 63: "青海", 64: "宁夏", 65: "新疆", 71: "台湾", 81: "香港", 82: "澳门" };
      if (pattern.test(val)) {
        if (provs[val]) {
          return true;
        }
      }
      return false;
    }
    var checkDate = function(val) {
      var pattern = /^(18|19|20)\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)$/;
      if (pattern.test(val)) {
        var year = val.substring(0, 4);
        var month = val.substring(4, 6);
        var date = val.substring(6, 8);
        var date2 = new Date(year + "-" + month + "-" + date);
        if (date2 && date2.getMonth() == (parseInt(month) - 1)) {
          return true;
        }
      }
      return false;
    }
    var checkCode = function(val) {
      var p = /^[1-9]\d{5}(18|19|20)\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/;
      var factor = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2];
      var parity = [1, 0, 'X', 9, 8, 7, 6, 5, 4, 3, 2];
      var code = val.substring(17);
      if (p.test(val)) {
        var sum = 0;
        for (var i = 0; i < 17; i++) {
          sum += val[i] * factor[i];
        }
        if (parity[sum % 11] == code.toUpperCase()) {
          return true;
        }
      }
      return false;
    }

    if (checkCode(id)) {
      var date = id.substring(6, 14);
      if (checkDate(date)) {
        if (checkProv(id.substring(0, 2))) {
          return true;
        }
      }
    }
    return false;
  },

}



// WEBPACK FOOTER //
// ./src/utils/global.js